import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
import { saveAs } from 'file-saver'
import useGlobal from '@/composables/useGlobal'
import { registrationCardResource } from '@/services/event-checkin.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationCard',
  props: {
  token: {
    type: String,
    required: true,
  },
  qrImageUrl: {
    type: String,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const { $t } = useGlobal()

const isLoad = ref(false)
const loadError = ref(false)
const isDownloading = ref(false)
const card = ref<any>(null)

const formattedCheckInTime = computed(() => {
  if (!card.value?.checkInTime) return ''
  return new Date(card.value.checkInTime).toLocaleString(window.language)
})

const getRegistrationCard = async () => {
  isLoad.value = true
  loadError.value = false

  try {
    const res = await registrationCardResource.execute({ token: props.token })
    const { data } = res

    card.value = data?.item || null

    if (!card.value) {
      loadError.value = true
    }
  } catch (e) {
    loadError.value = true
  } finally {
    isLoad.value = false
  }
}

const downloadQr = async () => {
  if (isDownloading.value) return

  isDownloading.value = true

  try {
    const response = await fetch(props.qrImageUrl)
    const blob = await response.blob()

    saveAs(blob, `qr-${props.token}.png`)
  } catch (e) {
    loadError.value = true
  } finally {
    isDownloading.value = false
  }
}

onMounted(() => {
  getRegistrationCard()
})

const __returned__ = { props, $t, isLoad, loadError, isDownloading, card, formattedCheckInTime, getRegistrationCard, downloadQr, ref, computed, onMounted, get saveAs() { return saveAs }, get useGlobal() { return useGlobal }, get registrationCardResource() { return registrationCardResource } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})